import clsx from 'clsx';
import React from 'react';

import { FieldConfig } from '../../config/fields';

import s from './FieldRow.module.scss';

type FieldRowProps = {
  field: FieldConfig;
  value: React.ReactNode | null;
};

export const FieldRow: React.FC<FieldRowProps> = ({ field, value }) => {
  if (value === null) return null;

  return (
    <div className={s.row}>
      <div className={s.key}>
        {field.icon}
        <span>{field.label}</span>
      </div>
      <div className={clsx(s.value, field.type === 'taskLink' && s.taskKey)}>{value}</div>
    </div>
  );
};
